/* eslint-disable unicorn/filename-case */
import z from "zod";

export const Locale = z.object({
    id: z.number(),
    display_name: z.string(),
});

export const Timezone = z.object({
    name: z.string(),
    display_name: z.string(),
});

export const Workflow = z.object({
    name: z.string(),
    display_name: z.string(),
});

export const BasicSettings = z.object({
    id: z.number(),
    name: z.string(),
    channel: z.string(),
    created_at: z.coerce.date(),
    default_locale_code: z.string(),
    default_locale_id: z.number(),
    deleted_at: z.null(),
    handle: z.string(),
    is_active: z.boolean(),
    locales: z
        .object({
            id: z.number(),
            name: z.string(),
            code: z.string(),
        })
        .array(),
    owner_id: z.number(),
    tenant_id: z.number(),
    timezone: z.string(),
    updated_at: z.coerce.date(),
    workflow_type: z.string(),
});

export const Locales = z.array(Locale);
export const Timezones = z.array(Timezone);
export const Workflows = z.array(Workflow);
